var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Col, Row } from "@riseart/antd-provider";
import { Heading, ExpandableOverflow, Markdown } from "@riseart/common";
import { nl2br, isStringMarkdown } from "@riseart/fe-utils";
import { artBioTitleAvatarCls } from "./Bio.less";
var DEFAULT_OPTIONS = {
  expandMaxHeight: 170,
  headingTag: "h3",
  headingLevel: 3
};
var ArtBio = /* @__PURE__ */ __name(function ArtBio2(_ref) {
  var name = _ref.name, _ref$profileLink = _ref.profileLink, profileLink = _ref$profileLink === void 0 ? null : _ref$profileLink, biography = _ref.biography, image = _ref.image, _ref$translations = _ref.translations, translations = _ref$translations === void 0 ? {} : _ref$translations, _ref$options = _ref.options, options = _ref$options === void 0 ? DEFAULT_OPTIONS : _ref$options;
  var Bio = /* @__PURE__ */ React.createElement(ExpandableOverflow, {
    showMore: translations.showMore,
    showLess: translations.showLess,
    maxHeight: options.expandMaxHeight || DEFAULT_OPTIONS.expandMaxHeight
  }, isStringMarkdown(biography) ? /* @__PURE__ */ React.createElement(Markdown, {
    text: biography
  }) : /* @__PURE__ */ React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: nl2br(biography)
    }
  }));
  return /* @__PURE__ */ React.createElement("section", null, /* @__PURE__ */ React.createElement(Heading, {
    tag: options.headingTag || DEFAULT_OPTIONS.headingTag,
    level: options.headingLevel || DEFAULT_OPTIONS.headingLevel
  }, image ? /* @__PURE__ */ React.createElement("span", {
    className: artBioTitleAvatarCls
  }, image) : null, name), image ? /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    xs: 0,
    md: 4
  }, image, profileLink), /* @__PURE__ */ React.createElement(Col, {
    xs: 24,
    md: 20
  }, Bio)) : Bio);
}, "ArtBio");
export {
  ArtBio
};
